// Увеличение фото по ссылкам a/area с data-lightbox или rel="lightbox…", как Lightbox2 2.9.0 с настройками
// сайта: окно, затемнение и фото появляются сразу (длительности 0), прокрутка страницы отключена.
// Плавно появляются только индикатор загрузки (600 мс) и подписи (200 мс). Разметка и классы те же:
// под них написаны стили тем. Показ, скрытие и размеры — как в jQuery 1.11.3 (lib/dollar.js).
import { $ } from './dollar';

const HTML = '<div id="lightboxOverlay" class="lightboxOverlay"></div><div id="lightbox" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" /><div class="lb-nav"><a class="lb-prev" href="" ></a><a class="lb-next" href="" ></a></div><div class="lb-loader"><a class="lb-cancel"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close"></a></div></div></div></div>';
const LINKS = 'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]';
// Кривая swing из jQuery: 0.5 - cos(πt) / 2.
const SWING = 'cubic-bezier(0.37, 0, 0.63, 1)';

export function installLightbox(doc) {
    const win = doc.defaultView;
    let body;
    let box;
    let overlay;
    let outer;
    let image;
    let frameX;
    let frameY;
    let album = [];
    let index = 0;
    const q = selector => box.querySelector(selector);
    const hidden = element => win.getComputedStyle(element).display === 'none';
    // fadeIn и fadeOut jQuery меняют только скрытый или только видимый элемент.
    const fadeIn = (element, duration) => {
        if (!hidden(element)) return;
        $(element).show();
        if (duration && element.animate) {
            element.animate([{ opacity: 0 }, { opacity: win.getComputedStyle(element).opacity || '1' }], { duration, easing: SWING });
        }
    };
    const fadeOut = element => {
        if (!hidden(element)) $(element).hide();
    };

    function sizeOverlay() {
        const html = doc.documentElement;
        $(overlay).width(Math.max(body.scrollWidth, html.scrollWidth, body.offsetWidth, html.offsetWidth, html.clientWidth));
        $(overlay).height(Math.max(body.scrollHeight, html.scrollHeight, body.offsetHeight, html.offsetHeight, html.clientHeight));
    }

    function keyup(event) {
        const key = String.fromCharCode(event.keyCode).toLowerCase();
        if (event.keyCode === 27 || /x|o|c/.test(key)) end();
        else if ((key === 'p' || event.keyCode === 37) && index !== 0) change(index - 1);
        else if ((key === 'n' || event.keyCode === 39) && index !== album.length - 1) change(index + 1);
    }

    function change(number) {
        doc.removeEventListener('keyup', keyup);
        fadeIn(overlay, 0);
        doc.querySelectorAll('.lb-loader').forEach(loader => fadeIn(loader, 600));
        $(box.querySelectorAll('.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-caption')).hide();
        outer.classList.add('animating');
        const preloader = new win.Image();
        preloader.onload = () => {
            image.setAttribute('src', album[number].link);
            let width = preloader.width;
            let height = preloader.height;
            // Фото помещается в окно браузера с рамкой и отступами, как в Lightbox2.
            const maxWidth = doc.documentElement.clientWidth - frameX - 20;
            const maxHeight = doc.documentElement.clientHeight - frameY - 120;
            if (width > maxWidth || height > maxHeight) {
                if (width / maxWidth > height / maxHeight) {
                    height = parseInt(height / (width / maxWidth), 10);
                    width = maxWidth;
                } else {
                    width = parseInt(width / (height / maxHeight), 10);
                    height = maxHeight;
                }
            }
            $(image).width(width).height(height);
            sizeContainer($(image).width(), $(image).height());
        };
        preloader.src = album[number].link;
        index = number;
    }

    function sizeContainer(width, height) {
        const newWidth = width + frameX;
        const newHeight = height + frameY;
        if (outer.offsetWidth !== newWidth || outer.offsetHeight !== newHeight) {
            outer.style.width = Math.max(0, newWidth) + 'px';
            outer.style.height = Math.max(0, newHeight) + 'px';
        }
        $(q('.lb-dataContainer')).width(newWidth);
        $(box.querySelectorAll('.lb-loader')).hide();
        fadeIn(image, 0);
        $(q('.lb-nav')).show();
        if (album.length > 1) {
            if (index > 0) $(q('.lb-prev')).show();
            if (index < album.length - 1) $(q('.lb-next')).show();
        }
        showDetails();
        [index + 1, index - 1].filter(i => i >= 0 && i < album.length).forEach(i => { new win.Image().src = album[i].link; });
        doc.addEventListener('keyup', keyup);
    }

    function showDetails() {
        const title = album[index].title;
        if (title !== undefined && title !== '') {
            const caption = q('.lb-caption');
            caption.innerHTML = title;
            fadeIn(caption, 200);
            // Окно отменяет переход по ссылке в подписи: ссылка открывается кодом.
            caption.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
                if (link.hasAttribute('target')) win.open(link.getAttribute('href'), link.getAttribute('target'));
                else win.location.href = link.getAttribute('href');
            }));
        }
        const number = q('.lb-number');
        if (album.length > 1) {
            number.textContent = 'Image ' + (index + 1) + ' of ' + album.length;
            fadeIn(number, 200);
        } else {
            $(number).hide();
        }
        outer.classList.remove('animating');
        fadeIn(q('.lb-dataContainer'), 0);
        sizeOverlay();
    }

    // Альбом — ссылки того же тега с тем же data-lightbox или rel. Значения сравниваются как текст:
    // кавычки в названии позиции не мешают (Lightbox2 падал на таком селекторе).
    function start(link) {
        win.addEventListener('resize', sizeOverlay);
        doc.querySelectorAll('select, object, embed').forEach(element => { element.style.visibility = 'hidden'; });
        sizeOverlay();
        const group = link.getAttribute('data-lightbox');
        const name = group ? 'data-lightbox' : 'rel';
        const value = link.getAttribute(name);
        const links = !group && value === 'lightbox' ? [link]
            : Array.from(doc.querySelectorAll(link.tagName + '[' + name + ']')).filter(item => item.getAttribute(name) === value);
        album = links.map(item => ({ link: item.getAttribute('href'), title: item.getAttribute('data-title') || item.getAttribute('title') || undefined }));
        box.style.top = (win.pageYOffset + 50) + 'px';
        box.style.left = win.pageXOffset + 'px';
        fadeIn(box, 0);
        body.classList.add('lb-disable-scrolling');
        change(Math.max(0, links.indexOf(link)));
    }

    function end() {
        doc.removeEventListener('keyup', keyup);
        win.removeEventListener('resize', sizeOverlay);
        fadeOut(box);
        fadeOut(overlay);
        doc.querySelectorAll('select, object, embed').forEach(element => { element.style.visibility = 'visible'; });
        body.classList.remove('lb-disable-scrolling');
    }

    // Обработчик Lightbox2 с return false: действие по умолчанию и всплытие отменяются.
    const stop = (element, handler) => element.addEventListener('click', event => {
        handler(event);
        event.preventDefault();
        event.stopPropagation();
    });

    // Окно строится при готовности документа, как в Lightbox2: после ядра сайта и после разметки страницы.
    function build() {
        body = doc.body;
        body.addEventListener('click', event => {
            if (event.button) return;
            for (let node = event.target; node && node !== body; node = node.parentNode) {
                if (node.nodeType === 1 && node.matches(LINKS)) {
                    start(node);
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
            }
        });
        const holder = doc.createElement('div');
        holder.innerHTML = HTML;
        Array.from(holder.childNodes).forEach(node => body.appendChild(node));
        box = doc.getElementById('lightbox');
        overlay = doc.getElementById('lightboxOverlay');
        outer = q('.lb-outerContainer');
        image = q('.lb-image');
        // Поля контейнера и рамка фото читаются один раз, как в Lightbox2.
        const padding = win.getComputedStyle(q('.lb-container'));
        const border = win.getComputedStyle(image);
        const frame = side => (parseInt(padding['padding' + side], 10) || 0) + (parseInt(border['border' + side + 'Width'], 10) || 0);
        frameX = frame('Left') + frame('Right');
        frameY = frame('Top') + frame('Bottom');
        $(overlay).hide();
        $(box).hide();
        stop(overlay, end);
        stop(box, event => { if (event.target.id === 'lightbox') end(); });
        stop(outer, event => { if (event.target.id === 'lightbox') end(); });
        stop(q('.lb-prev'), () => change(index === 0 ? album.length - 1 : index - 1));
        stop(q('.lb-next'), () => change(index === album.length - 1 ? 0 : index + 1));
        stop(q('.lb-loader'), end);
        stop(q('.lb-close'), end);
        // Правая кнопка мыши: стрелки пропускают события к фото, чтобы открылось его контекстное меню.
        const nav = q('.lb-nav');
        nav.addEventListener('mousedown', event => {
            if (event.button !== 2) return;
            nav.style.pointerEvents = 'none';
            box.addEventListener('contextmenu', () => win.setTimeout(() => { nav.style.pointerEvents = 'auto'; }, 0), { once: true });
        });
    }

    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', build);
    else build();
}
